import * as actions from './actions'
import { CONVERSATION_STATUS } from '@/constant'

const initState = {
  audios: [], // 语音播放组件，为解决多个语音播放的问题
  imStatus: 3, // 客服当前在线转态
  imExpiryStatus: false, // im长连状态 true：401状态
  shortcutSearchKeywords: '', // 输入聊天关键字匹配常用语
  userList: [], // 会话中用户聊天列
  userListLoading: false, // 会话中用户聊天列表加载状态
  userListLoadSuccess: false, // 会话中用户聊天列表加载状态
  historyList: {
    data: [], // 历史会话列表
    page: 1, // 历史当前页数
    end: false, // 历史数据是否已全部加载
    loading: false // 是否加载历史数据中
  },
  currentService: {}, // 当前聊天对象
  isHistory: false, // 是否在历史会话
  invited: false, // 是否已邀评
  workingObj: {} // 工作台信息
}

const getters = {
  /* 个人信息 */
  audios: state => state.audios, // 聊天语音组件list
  userList: state => state.userList, // 聊天列表
  historyList: state => state.historyList, // 历史会话列表
  conversationId: state => state.currentService?.conversationId, // 当前选中会话id
  currentService: state => state.currentService,
  isHistory: state => state.isHistory,
  isCurrentOnline: state => state.currentService?.status === CONVERSATION_STATUS.ON_GOING,
  invited: state => state.invited,
  workingObj: state => state.workingObj,
  imExpiryStatus: state => state.imExpiryStatus,
  shortcutSearchKeywords: state => state.shortcutSearchKeywords,
  userListLoading: state => state.userListLoading,
  userListLoadSuccess: state => state.userListLoadSuccess
}

const mutations = {
  setAudioList: (state, data) => {
    state.audios = data
  },
  pushAudioList: (state, data) => {
    state.audios.push(data)
  },
  setImExpiryStatus: (state, data) => {
    state.imExpiryStatus = data
  },
  setUserList: (state, data) => {
    state.userList = data
  },
  setUserListLoading: (state, data) => {
    state.userListLoading = data
  },
  setUserListLoadSuccess: (state, data) => {
    state.userListLoadSuccess = data
  },
  setHistoryList: (state, data) => {
    state.historyList = data
  },
  setConversationId: (state, data) => {
    state.conversationId = data
  },
  setShortcutSearchKeywords: (state, data) => {
    state.shortcutSearchKeywords = data
  },
  // 设置当前会话数据
  setCurrentService: (state, data) => {
    state.currentService = { ...state.currentService, ...data }
  },
  clearCurrentService: state => {
    state.currentService = {}
  },
  setIsHistory: (state, data) => {
    state.isHistory = data
  },
  setInvited: (state, data) => {
    state.invited = data
  },
  setWorkingObj: (state, data) => {
    state.workingObj = { ...state.workingObj, ...data }
  }
}
export default {
  actions,
  state: initState,
  getters,
  mutations
}
